// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Debugging helpers (temporary — remove once fixed)
if (!firebaseConfig.apiKey) {
  // Don't log the actual key. Log presence only.
  // This helps you confirm whether build-time env was injected.
  // Remove these logs after debugging.
  // eslint-disable-next-line no-console
  console.error(
    "FIREBASE CONFIG ERROR: apiKey is missing in the built bundle. " +
      "Make sure REACT_APP_FIREBASE_API_KEY is present as a GitHub secret and that .env is created before build."
  );
} else {
  // eslint-disable-next-line no-console
  console.log("Firebase apiKey is present in the built bundle (value not shown).");
}

let app = null;
try {
  if (firebaseConfig.apiKey) {
    app = initializeApp(firebaseConfig);
  } else {
    // Avoid calling initializeApp with an invalid config which throws auth/invalid-api-key
    // Consumers should handle null exports while debugging.
    // eslint-disable-next-line no-console
    console.warn("Skipping Firebase initialization because apiKey is missing.");
  }
} catch (err) {
  // eslint-disable-next-line no-console
  console.error("Error initializing Firebase:", err);
  app = null;
}

export const auth = app ? getAuth(app) : null;
export const database = app ? getDatabase(app) : null;
export const db = database;
export const firestore = app ? getFirestore(app) : null;
export const storage = app ? getStorage(app) : null;

export default app;